import { Text } from '@react-pdf/renderer'
import { TimeMeasurementValue } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { formatMinutes } from 'src/exShared/util/report/formatMinutes'
import { gridLayoutTableBodyCell } from '../../../shared/styles'

type Props = {
  value?: TimeMeasurementValue
}

export const TableBodyCellTimeMeasurement: FC<Props> = ({ value }) => {
  return (
    <Text
      style={[
        gridLayoutTableBodyCell.baseTableBodyCell,
        gridLayoutTableBodyCell.tableBodyCell,
      ]}
    >
      {formatMinutes(value?.value || 0)}
    </Text>
  )
}
